import React, { useState, useEffect } from 'react';
import LoginForm from './LoginForm';
import LoginFormPhone from './LoginFormPhone';

type LoginMethod = 'username' | 'phone';

const STORAGE_KEY = 'preferred_login_method';

interface LoginFormContainerProps {
    onLoginMethodChange?: (method: LoginMethod) => void;
    initialPhone?: string;
    preferPhoneLogin?: boolean;
}

const LoginFormContainer: React.FC<LoginFormContainerProps> = ({
    onLoginMethodChange,
    initialPhone,
    preferPhoneLogin,
}) => {
    const [loginMethod, setLoginMethod] = useState<LoginMethod>('username');

    useEffect(() => {
        if (preferPhoneLogin) {
            setLoginMethod('phone');
            localStorage.setItem(STORAGE_KEY, 'phone');
            onLoginMethodChange?.('phone');
            return;
        }

        const savedMethod = localStorage.getItem(STORAGE_KEY) as LoginMethod;
        if (savedMethod && (savedMethod === 'username' || savedMethod === 'phone')) {
            setLoginMethod(savedMethod);
            onLoginMethodChange?.(savedMethod);
        }
    }, [onLoginMethodChange, preferPhoneLogin]);

    const switchToPhone = () => {
        setLoginMethod('phone');
        localStorage.setItem(STORAGE_KEY, 'phone');
        onLoginMethodChange?.('phone');
    };

    const switchToUsername = () => {
        setLoginMethod('username');
        localStorage.setItem(STORAGE_KEY, 'username');
        onLoginMethodChange?.('username');
    };

    return (
        <>
            {loginMethod === 'username' ? (
                <LoginForm onSwitchToPhone={switchToPhone} />
            ) : (
                <LoginFormPhone onSwitchToUsername={switchToUsername} initialPhone={initialPhone} />
            )}
        </>
    );
};

export default LoginFormContainer;
